import { NewPasswordLogin, UsernamePasswordLogin } from "@/shared/coralreef";
import { viewWidth } from "csx";
import { Content } from "gls/lib";
import { useState } from "react";

const NEW_PASSWORD_REQUIRED = "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED";

export interface LoginPageProps {
  signIn(
    email: string,
    password: string,
  ): Promise<{ isSignedIn: boolean; nextStep?: { signInStep: string } }>;
  confirmSignIn(newPassword: string): Promise<{ isSignedIn: boolean }>;
  onSuccess(): void;
}

export function LoginPage({
  signIn,
  confirmSignIn,
  onSuccess,
}: LoginPageProps) {
  const [error, setError] = useState<string | null>(null);
  const [newPasswordRequired, setNewPasswordRequired] = useState(false);

  const onLoginPasswordSubmitHandler = (username: string, password: string) => {
    setError(null);
    signIn(username, password)
      .then((r) => {
        if (r.isSignedIn) {
          onSuccess();
        } else if (r.nextStep?.signInStep === NEW_PASSWORD_REQUIRED) {
          setNewPasswordRequired(true);
        }
      })
      .catch((e) => {
        setError(e instanceof Error ? e.message : "Sign-in failed");
      });
  };

  const onNewPasswordSubmitHandler = (newPassword: string) => {
    setError(null);
    confirmSignIn(newPassword)
      .then((r) => {
        if (r.isSignedIn) onSuccess();
      })
      .catch((e) => {
        setError(e instanceof Error ? e.message : "Failed to set new password");
      });
  };

  return (
    <Content
      width={viewWidth(100)}
      height="75vh"
      verticalAlign="center"
      horizontalAlign="center"
    >
      <div className="flex flex-col items-center gap-3">
        {newPasswordRequired ? (
          <NewPasswordLogin onSubmit={onNewPasswordSubmitHandler} />
        ) : (
          <UsernamePasswordLogin onSubmit={onLoginPasswordSubmitHandler} />
        )}
        {error && (
          <div
            role="alert"
            data-testid="error-message"
            className="text-red-500 text-sm w-[300px]"
          >
            {error}
          </div>
        )}
      </div>
    </Content>
  );
}
